module.exports = __webpack_public_path__ + "img/badge-wc.253e6896.svg";